import { createIcon } from '@chakra-ui/react';

export const BatteryExhaustedIcon = createIcon({
  displayName: 'BatteryExhaustedIcon',
  viewBox: '0 0 22 20',
  defaultProps: { fill: 'none', width: '22', height: '20' },
  path: (
    <path
      d="M20.5312 18.6807L19.4707 19.7412L14.7559 15.0264H1.57617C0.705959 15.0264 0.000256763 14.3204 0 13.4502V6.29199C3.63463e-05 5.42165 0.705822 4.71582 1.57617 4.71582H4.44531L0.790039 1.06055L1.85059 0L20.5312 18.6807ZM18.6455 4.71582C19.5158 4.71594 20.2216 5.42172 20.2217 6.29199V7.6709C20.2466 7.66955 20.2716 7.66798 20.2969 7.66797C21.0571 7.66797 21.6738 8.28469 21.6738 9.04492V10.6963C21.6738 11.4566 21.0571 12.0732 20.2969 12.0732C20.2716 12.0732 20.2466 12.0707 20.2217 12.0693V13.4502C20.2215 14.1566 19.7559 14.754 19.1152 14.9541L17.6875 13.5264H18.6455C18.6872 13.5262 18.7214 13.4919 18.7217 13.4502V6.29199C18.7216 6.25015 18.6873 6.21594 18.6455 6.21582H10.377L8.87695 4.71582H18.6455ZM1.57617 6.21582C1.53425 6.21582 1.50004 6.25008 1.5 6.29199V13.4502C1.50026 13.4919 1.53438 13.5264 1.57617 13.5264H13.2559L5.94531 6.21582H1.57617Z"
      fill="#EF4E4E"
    />
  ),
});
